import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import PPPDeck from './PPPDeck';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <PPPDeck />
  </React.StrictMode>
);